import { transform } from '@utils/intl_lang'
const ColumnItemTypeEnum = [
  // "课程"
  { type: '0', name: transform('course'), toUrl: '/znWeb/course/detail.html' },
  // '自定义专题'
  { type: '3', name: transform('custom_theme') },
  // '资讯'
  { type: '1', name: transform('infor_list') },
  // "课程专题"
  { type: '12', name: transform('course_topics') },
  // "考试"
  { type: '30', name: transform('exam'), toUrl: '/znWeb/exam/detail.html' },
  // "直播"
  { type: '31', name: transform('live') }, // 正在直播
  // "直播"
  { type: '33', name: transform('live') }, // 直播回放
  // "面授班"
  { type: '51', name: transform('training_class') }, // 面授班
  // "培训项目"
  { type: '87', name: transform('training_project') }, // 面授班
  // "圈子"
  { type: '90', name: transform('circle') },
  // "帖子"
  { type: '91', name: transform('search_invitation') },
  // 云校培训项目详情页
  { type: '109', name: transform('cloud_school_project') },
  //云校培训项目公开列表
  { type: '110', name: transform('cloud_school_project_list') },
  // 功能模块
  { type: '4', name: '功能模块'},
  { type: '188', name: '排行榜'}
]
const resoureTypes = {
  // "课程"
  '0': {
    name: transform('course'),
    key: 'course',
    toUrl: '#/home/courseDetail',
    isBlank: true,
  },
  // '自定义专题'
  '3': {
    name: transform('custom_theme'),
    key: 'seminar',
    toUrl: '/home/seminar',
    isBlank: false,
  },
  // '资讯'
  '1': {
    name: transform('infor_list'),
    key: 'information',
    toUrl: '/home/information',
    isBlank: false,
  },
  // '课程专题'
  '12': {
    name: transform('course_topics'),
    key: 'courseToptic',
    toUrl: '/home/courseToptic',
    isBlank: false,
  },
  // "考试"
  '30': {
    name: transform('exam'),
    key: 'exam',
    toUrl: '/znWeb/exam/detail.html',
    isBlank: true,
  },
  // '正在直播'
  '31': {
    name: transform('living'),
    key: 'living',
    toUrl: '/liveRoom',
    isBlank: false,
  },
  // '直播回放'
  '33': {
    name: transform('living_replay'),
    key: 'lived',
    toUrl: '/liveRoom',
    isBlank: false,
  },
  // '考试'
  '37': {
    name: transform('exam'),
    key: 'exam',
    toUrl: '/znWeb/exam/detail.html',
    isBlank: true,
  },
  // '面授班'
  '51': {
    name: transform('training_class'),
    key: 'training',
    toUrl: '/home/myTrainingClass',
    isBlank: true,
  },
  // '作业'
  '66': {
    name: transform('homeWork'),
    key: 'homework',
    toUrl: '/home/homework',
    isBlank: false,
  },
  // '文库'
  '120': {name: transform('Knowledge_lib'), key:'knowledgeLibDetail', toUrl:'/home/knowledgeLibDetail', isBlank:true},
  // "培训项目"
  '87': {
    name: transform('training_project'),
    key: 'humanTraining',
    toUrl: '/home/humanTraining',
    isBlank: false,
  }, // 培训项目
  // '圈子'
  '90': {
    name: transform('circle'),
    key: 'circle',
    toUrl: '/home/topicDetail',
    isBlank: false,
  }, // 圈子
  // '帖子'
  '91': {
    name: transform('search_invitation'),
    key: 'post',
    toUrl: '/home/postDetail',
    isBlank: false,
  }, // 帖子
  '109': {
    // 云校培训项目详情页
    name: transform('cloud_school_project'),
    key: 'openTrainingDetail',
    toUrl: '/home/openTrainingDetail',
    isBlank: true,
  },
  '110': {
    // 云校培训项目公开列表
    name: transform('cloud_school_project_list'),
    key: 'openTrainingProjectList',
    toUrl: '/home/openTrainingProjectList',
    isBlank: true,
  },
  '117': {
    // 文件
    name: transform('files'),
    key: 'filePreview',
    toUrl: '/filePreview',
    isBlank: true,
  },
}

enum RESOURCE_ENUM {
  /** 课程 */
  'COURSE' = 0,
  /** 资讯 */
  'NEWS' = 1,
  /** 话题 */
  'TOPIC' = 2,
  /** 自定义专题 */
  'SEMINAR' = 3,
  /** 课程专题 */
  'COURSE_SUBJECT' = 12,
  /** 自建课程 */
  'SELF_BUILT_COURSE' = 28,
  /** 共享课程 */
  'SHARING_COURSE' = 29,
  /** 考试 */
  'EXAM' = 30,
  /** 直播 */
  'LIVE' = 31,
  /** 直播回放 */
  'LIVE_PLAYBACK' = 33,
  /** 智能陪练 */
  'INTELLIGENT_TRAIN' = 38,
  /** 学习全景图 */
  'STUDY_PANORAMA' = 46,
  /** 面授课程注册 */
  'FACE_COURSE_ENROLL' = 48,
  /** 培训班 */
  'TRAINING_CLASS' = 51,
  /** 面授课程 */
  'RESOURCE_SELECTOR' = 45,
  /** 阶段学习项目 */
  'STUDY_MAP' = 56,
  /** 培训项目 */
  'HUMAN_TRAIN' = 87,
  /** 新问卷 */
  'NEW_QUESTIONNAIRE' = 57,
  /** 旧问卷 */
  'QUESTIONNAIRE' = 22,
  /** 知圈 */
  'KNOWING_CIRCLE' = 90,
  /** 帖子 */
  'POST' = 91,
  /** 作业 */
  'HOMEWORK' = 66,
  /** 功能模块 */
  'FUNCTION_MODEL' = 4,
  /** 云校培训项目详情页 */
  'CLOUD_TRAIN_DETAIL' = 109,
  /** 云校培训项目列表页面 */
  'CLOUD_TRAIN' = 110,
  /** 首页 */
  'HOME' = 60,
  /** 排行榜 */
  'RANK_LIST' = 188,
}

/** 资讯列表 */
const INFO_LIST = 1

/** 功能模块 */
const FUNCTION_MODEL = 4

export { ColumnItemTypeEnum, resoureTypes, RESOURCE_ENUM, INFO_LIST, FUNCTION_MODEL }
